export interface ITimeLine {
  stepTitle: string;
  isActive: boolean;
  stepNumber: number;
  isStepCompleted: boolean;
}

export const TIMELINE_STATUS: ITimeLine[] = [
  { stepTitle: 'Sign up', isActive: true, stepNumber: 1, isStepCompleted: false },
  { stepTitle: 'Security', isActive: false, stepNumber: 2, isStepCompleted: false },
  { stepTitle: 'Data', isActive: false, stepNumber: 3, isStepCompleted: false },
  { stepTitle: 'Preferences', isActive: false, stepNumber: 4, isStepCompleted: false }
];

// Wizard step indices (0-based, as used by SignUpStateService.currentStep)
export const SIGN_UP_STEP = {
  PASSWORD: 0,
  SECURITY: 1,
  TERMS: 2,
  PREFERENCES: 3
} as const;
